/*
 * Copyright (c) 2017-2026 Brighter AI Technologies GmbH. All rights reserved.
 * Unauthorized use, copying, reproduction, or distribution of this file, via any medium,
 * is strictly prohibited.
 */

import Joi from "joi";

const envSchema = Joi.object({
  REACT_APP_AAD_TENANT_ID: Joi.string().required(),
  REACT_APP_AAD_REDIRECT_URI: Joi.string().required(),
  REACT_APP_AAD_SIGN_IN_POLICY: Joi.string().required(),
  REACT_APP_AAD_PASSWORD_RESET_POLICY: Joi.string().required(),
  REACT_APP_BACKEND_URI: Joi.string().required(),
  REACT_APP_AAD_AUTHORITY: Joi.string().required(),
  REACT_APP_STRIPE_PK: Joi.string()
    .required()
    .pattern(/(^<\w+>)/, { invert: true }),
}).unknown();

export function validateEnvironmentVariables() {
  const environment = envSchema.validate(process.env);

  if (environment.error) {
    console.error(environment.error);
    throw environment.error;
  }
}
